<template>
  <div class="container">
    <div class="help_tel">
      <div class="container">
        <h3 :style="{ fontSize: fontSize.h3 + 'em' }">緊急服務專線</h3>
        <div class="item">
          <a
            :style="{ fontSize: fontSize.h3 + 'em' }"
            title="急難救助全球免付費專線"
            href="tel:0800-085-095"
            >0800-085-095
          </a>
        </div>
      </div>
      <div class="container container2">
        <div class="phone2">
          <h4 :style="{ fontSize: fontSize.h3 + 'em' }">
            急難救助全球免付費專線
          </h4>
          <div class="item">
            <a
              :style="{ fontSize: fontSize.h3 + 'em' }"
              title="急難救助全球免付費專線"
              href="tel:0800 0885 0885"
              >800-0885-0885
            </a>
          </div>
        </div>
        <a
          title="[另開新視窗]急難救助全球免付費專線撥打使用說明"
          class="call"
          href="https://www.boca.gov.tw/cp-87-2121-7a5da-1.html"
          :style="{ fontSize: fontSize.p + 'em' }"
          target="_blank"
          >撥打使用說明
        </a>
      </div>
    </div>
  </div>
</template>
<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
export default {
  name: "CallHelpTel",
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  .phone2 {
    display: flex;
    align-items: center;
  }
  .help_tel {
    padding: 20px 0;
    .container {
      @include flex_center();
      @include lg {
        font-size: 0.8em;
      }
      @include md {
        font-size: 0.7em;
      }
      @include xs {
        font-size: 0.5em;
      }

      .item {
        @include flex_center();
        @include md {
          padding-top: 5px;
        }
        @include sm {
          flex-direction: column;
          padding-top: 0;
        }
        h5 {
          color: #fff;
        }
      }
      a {
        display: inline-block;
        margin: 3px 15px;
        color: $black_color;
      }
      .call {
        margin-top: 10px;
        padding: 5px 10px;
        color: $main_sec_color;
        background-color: $main_color;
      }
    }
  }
}
.container2 {
  @include lg {
    flex-direction: column;
  }
}
</style>
